export const canShowDocumentationActions = (isSuperAdmin: boolean) =>
	isSuperAdmin;
